// Runtime environment variables, injected into window.__ENV__ by /env-config.js.
//
// In Docker, /env-config.js is regenerated on every container start by
// docker-entrypoint.sh from the PG_MERCHANT_* env vars supplied via the global
// drone/swarm env files (--env-file /platform-env/global.env + production.env).
// For local dev the defaults in public/env-config.js are used.
const env = (typeof window !== "undefined" && window.__ENV__) || {};

// Only trust an injected URL if it is a well-formed absolute http(s)/ws(s) URL.
// This guards against typos in the runtime env files (e.g. "hhttps://…", which
// makes axios throw "Unsupported protocol"): a malformed value is treated as
// absent so the app falls back to the hostname-based defaults in
// DynamicPortalFunctions.js instead of breaking every request.
const sanitizeUrl = (value) => {
  if (typeof value !== "string") return "";
  const trimmed = value.trim();
  return /^(https?|wss?):\/\//i.test(trimmed) ? trimmed : "";
};

export const PG_MERCHANT_API_BASE_URL = sanitizeUrl(env.PG_MERCHANT_API_BASE_URL);
export const PG_MERCHANT_WS_BASE_URL = sanitizeUrl(env.PG_MERCHANT_WS_BASE_URL);
export const PG_MERCHANT_DOC_BASE_URL = sanitizeUrl(env.PG_MERCHANT_DOC_BASE_URL);

export default env;
